<template>
  <span :class="`z-checkbox ${checked ? 'z-checkbox-checked' : ''}`">
    <span class="z-checkbox-inner"></span>
    <input type="checkbox" class="z-checkbox-input" :checked="checked" @change="onChange" />
  </span>
</template>

<script>
export default {
  name: 'ZCheckbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: ['checked'],
  methods: {
    onChange(event) {
      this.$emit('change', event.target.checked)
    }
  }
}
</script>

<style lang="postcss">
.z-checkbox {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
  cursor: pointer;
  outline: 0;
  line-height: 1;
  overflow: hidden;
  width: 14px;
  height: 14px;

  .z-checkbox-inner {
    width: 14px;
    height: 14px;
    display: inline-block;
    border: 1px solid #d7dde4;
    border-radius: 2px;
    background-color: #fff;
    transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;
  }

  .z-checkbox-input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    cursor: pointer;
    opacity: 0;
  }

  &:hover .z-checkbox-inner {
    border-color: #bcbcbc;
  }

  &.z-checkbox-checked .z-checkbox-inner {
    border-color: #39f;
    background-color: #39f;

    &:after {
      content: '';
      display: table;
      width: 4px;
      height: 8px;
      position: absolute;
      top: 1px;
      left: 4px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(1);
      transition: all 0.2s ease-in-out;
    }
  }
}
</style>
